// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-articles-js": () => import("./../../../src/templates/articles.js" /* webpackChunkName: "component---src-templates-articles-js" */),
  "component---src-templates-braintree-js": () => import("./../../../src/templates/braintree.js" /* webpackChunkName: "component---src-templates-braintree-js" */),
  "component---src-templates-btfile-js": () => import("./../../../src/templates/btfile.js" /* webpackChunkName: "component---src-templates-btfile-js" */),
  "component---src-templates-help-js": () => import("./../../../src/templates/help.js" /* webpackChunkName: "component---src-templates-help-js" */)
}

